import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Section,
    Title,
    List,
    RowLink,
    RowButton,
    RowIcon,
    RowText,
    RowTitle,
    RowSubtitle,
    Chevron,
} from './ChecklistRow.styles';

/** "Siguientes pasos" list. */
export const NextSteps = ({ title, children }) => (
    <Section>
        <Title>{title}</Title>
        <List>{children}</List>
    </Section>
);

/**
 * Checklist item: a router link (or a disabled button in demo mode).
 */
export const ChecklistRow = ({
    icon,
    title,
    subtitle,
    to,
    highlight = false,
    disabled = false,
    onClick,
}) => {
    const { t } = useTranslation();
    const content = (
        <>
            <RowIcon highlight={highlight} aria-hidden="true">
                <i className={icon} />
            </RowIcon>
            <RowText>
                <RowTitle>{title}</RowTitle>
                <RowSubtitle>{disabled ? t('SignUpV2.demo.unavailable') : subtitle}</RowSubtitle>
            </RowText>
            <Chevron className="ri-arrow-right-s-line" aria-hidden="true" />
        </>
    );

    return (
        <li>
            {disabled ? (
                <RowButton type="button" aria-disabled="true" highlight={highlight}>
                    {content}
                </RowButton>
            ) : (
                <RowLink to={to} onClick={onClick} highlight={highlight}>
                    {content}
                </RowLink>
            )}
        </li>
    );
};
